import React from 'react';
import { Slider, Typography } from '@mui/material';
import { Sidebar } from './Sidebar';

interface PriceFilterProps {
  onClose: () => void;
  runFilter: () => void;
  selectedPriceValues: [number, number];
  onChange: (values: [number, number]) => void;
}

export const PriceFilter: React.FC<PriceFilterProps> = ({
  onClose,
  runFilter,
  selectedPriceValues,
  onChange
}) => {
  const handleChange = (_event: Event, newValue: number | number[]) => {
    onChange(newValue as [number, number]);
  };

  function valuetext(value: number) {
    return `€ ${value}`;
  }

  return (
    <Sidebar title="Price Filter" onClose={onClose} showDoneButton={false}>
      <div style={{ padding: 24, height: '85%', overflowY: 'auto' }}>
        <Slider
          getAriaLabel={() => 'Price Range'}
          value={selectedPriceValues}
          onChange={handleChange}
          valueLabelDisplay="auto"
          getAriaValueText={valuetext}
        />
        <div>
          <Typography>
            €{selectedPriceValues[0]} - €{selectedPriceValues[1]}
          </Typography>
        </div>
      </div>
    </Sidebar>
  );
};
